export { default } from "./diagram6Chart.component";
